const items = state => state.items.data
const error = state => state.error
const isLoading = state => state.isLoading
//
const item = state => state.item.data
const docs = state => state.docs.data
const isDownloading = state => state.isDownloading
//
const errorDownloading = state => state.errorDownloading
const isUploading = state => state.isUploading
const errorUploading = state => state.errorUploading
//
const isLoadingPrice = state => state.isLoadingPrice
const errorPrice = state => state.errorPrice
const prices = state => state.prices.data
//
const isLoadingInvoice = state => state.isLoadingInvoice
const errorInvoice = state => state.errorInvoice
const invoices = state => state.invoices.data
//
const isUploaded = state => state.isUploaded
const isLoadingDoc = state => state.isLoadingDoc
const errorDoc = state => state.errorDoc
//
const isPostingReq = state => state.isPostingReq
const isSuccessfulReq = state => state.isSuccessfulReq
const erroReq = state => state.erroReq
//
const otif = state => state.otif.data
const errorOtif = state => state.errorOtif
const otifIsLoading = state => state.otifIsLoading
// leadtime
const leadTimeItem = state => state.leadTimeItem.data
const isLeadTimeLoading = state => state.isLeadTimeLoading
const isLeadtimeError = state => state.isLeadtimeError
// update details
const isUpdating = state => state.isUpdating
const isUpdated = state => state.isUpdated.data
const errorUpdate = state => state.errorUpdate
// download price detail
const downloadPriceDetail = state => state.downloadPriceDetail.data
const errorDownloadPriceDetail = state => state.errorDownloadPriceDetail
const isLoadingDownloadPriceDetail = state => state.isLoadingDownloadPriceDetail
// history manage shipment
const history = state => state.history.data
const isLoadingHistory = state => state.isLoadingHistory
const errorHistory = state => state.errorHistory.data
// active user
const activeUser = state => state.activeUser.data
const isLoadingActiveUser = state => state.isLoadingActiveUser
const errorActiveUser = state => state.errorActiveUser.data
// pending user
const pendingUser = state => state.pendingUser.data
const isLoadingPendingUser = state => state.isLoadingPendingUser
const errorPendingUser = state => state.errorPendingUser.data

const getDelayLog = state => state.getDelayLog.data
const isLoadingGetDelayLog = state => state.isLoadingGetDelayLog
const isErrorGetDelayLog = state => state.isErrorHetDelayLog

const getFilterShipment = state => state.getFilterShipment.data
const errorGetFilterShipment = state => state.errorGetFilterShipment
const isLoadingGetFilterShipment = state => state.isLoadingGetFilterShipment

const downloadEfbl = state => state.downloadEfbl.data
const errorDownloadEfbl = state => state.errorDownloadEfbl
const isLoadingDownloadEfbl = state => state.isLoadingDownloadEfbl

const count = state => {
  let arr = state.items.data
  if (arr) {
    let booked = arr.filter(obj => {
      return obj.orderStat === 'BOOKED'
    })
    let payment = arr.filter(obj => {
      return obj.orderStat === 'PAYMENT'
    })
    let complete = arr.filter(obj => {
      return obj.orderStat === 'COMPLETED_OTIF'
    })
    let ongoing = arr.filter(obj => {
      return obj.orderStat !== 'BOOKED' && obj.orderStat !== 'COMPLETED' &&
      obj.orderStat !== 'PAYMENT' && obj.orderStat !== 'REJECTED' &&
      obj.orderStat !== 'COMPLETED_OTIF'
    })

    let obj = {
      booked: booked.length,
      payment: payment.length,
      complete: complete.length,
      ongoing: ongoing.length
    }

    return obj
  }
}

export default {
  isLoading,
  items,
  error,
  //
  item,
  docs,
  isDownloading,
  //
  errorDownloading,
  isUploading,
  errorUploading,
  //
  isLoadingPrice,
  errorPrice,
  prices,
  //
  isLoadingInvoice,
  errorInvoice,
  invoices,
  //
  isUploaded,
  isLoadingDoc,
  errorDoc,
  //
  isPostingReq,
  isSuccessfulReq,
  erroReq,
  //
  count,
  //
  otif,
  errorOtif,
  otifIsLoading,
  //
  leadTimeItem,
  isLeadTimeLoading,
  isLeadtimeError,
  // update details
  isUpdating,
  isUpdated,
  errorUpdate,
  // download price detail
  downloadPriceDetail,
  errorDownloadPriceDetail,
  isLoadingDownloadPriceDetail,
  // history
  history,
  isLoadingHistory,
  errorHistory,
  // active user
  activeUser,
  isLoadingActiveUser,
  errorActiveUser,
  // pending user
  pendingUser,
  isLoadingPendingUser,
  errorPendingUser,

  getDelayLog,
  isLoadingGetDelayLog,
  isErrorGetDelayLog,
  // filter shipment
  getFilterShipment,
  errorGetFilterShipment,
  isLoadingGetFilterShipment,

  downloadEfbl,
  errorDownloadEfbl,
  isLoadingDownloadEfbl
}



// WEBPACK FOOTER //
// ./src/store/modules/shipment/getters.js